import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { gymInfo, heroImages } from '../data/mockData';

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      {/* Background Image */}
      <div className="hero-background">
        <img 
          src={heroImages.main}
          alt="House of Fitness"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-5 md:px-10 relative z-10">
        <div className="hero-content">
          <h1 className="hero-title">
            HOUSE OF FITNESS
          </h1>
          <p className="body-large max-w-lg mb-8">
            {gymInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href={gymInfo.membershipUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary flex items-center justify-center gap-2"
            >
              <span>הצטרף עכשיו</span>
              <ArrowLeft size={20} className="transform rotate-180" />
            </a>
            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="btn-secondary"
            >
              צור קשר
            </button>
          </div>
        </div>
      </div>

      {/* Decorative Ribbon */}
      <div className="creative-ribbon hidden md:flex">
        <span className="text-2xl font-bold tracking-wider">
          בואו להתאמן איתנו במקום הכי יפה בארץ
        </span>
      </div>
    </section>
  );
};

export default Hero;
